// @flow
import React from 'react';

import LineUpSection from './LineUpSection';
import TableHead from './TableHead';

type Props = {
  positions: Array<Object>,
  onSelectSettingsTab: (tab: string) => void,
  onSwitchSelectedPosition: () => void,
  remainingSelections: number,
  onRemove: () => void
};

const columns = [
  {
    field: 'pos',
    label: 'POS',
    size: 1,
    sortable: false
  },
  {
    field: 'player',
    label: 'PLAYER',
    size: 6,
    sortable: false
  },
  {
    field: 'salary',
    label: 'SALARY',
    size: 2,
    sortable: false
  },
  {
    field: 'star',
    sortable: false,
    size: 3
  }
];

const LineUpTable = ({
  onSelectSettingsTab,
  onSwitchSelectedPosition,
  onRemove,
  positions,
  remainingSelections
}: Props) => {
  return (
    <div>
      <TableHead columns={columns} />
      {positions.map((position, i) => (
        <LineUpSection
          key={i} // eslint-disable-line
          onSelectSettingsTab={onSelectSettingsTab}
          onSwitchSelectedPosition={onSwitchSelectedPosition}
          onRemove={onRemove}
          position={position}
          positions={positions}
          remaining={
            position.shareQuota && position.isTeam
              ? 0
              : Math.min(position.max - position.selected, remainingSelections)
          }
        />
      ))}
    </div>
  );
};

export default React.memo(LineUpTable);
